const validateForm = (formValues) => {
  const errors = {};
  // Name validation
  if (!formValues.firstName.trim()) {
    errors.firstName = "El nombre es necesario.";
  } else if (formValues.firstName.length < 2) {
    errors.firstName = "Ingrese un nombre valido.";
  }
  // userName validation
  if (!formValues.nickName) {
    errors.nickName = "El nickName es necesario.";
  } else if (formValues.nickName.length < 2) {
    errors.nickName = "Ingrese un nuckName valido.";
  }
  // Email validation
  if (!formValues.email) {
    errors.email = "El email es requerrido.";
  } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
    errors.email = "Ingrese un email valido.";
  }

  // Password validation
  if (!formValues.password) {
    errors.password = "La contraseña es necesaria.";
  } else if (formValues.password.length < 8) {
    errors.password = "Debe ser mayor a 8 caracteres.";
  }

  return errors;
};
export default validateForm;
